import { FunctionComponent } from 'react'
import { createPortal } from 'react-dom'
import { Box } from '@black-bear-energy/rucksack'

export const CenteredModal: FunctionComponent<CenteredModalProps> = ({
  open,
  children,
}) => {
  if (!open) return null

  return createPortal(
    <Box
      sx={{
        position: 'fixed',
        inset: '0px',
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        zIndex: 1300,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          width: '600px',
          padding: '16px',
          flexDirection: 'column',
          alignItems: 'flex-start',
          gap: '20px',
          borderRadius: '8px',
          backgroundColor: '#FFF',
          boxShadow: '0 4px 4px 0 rgba(0, 0, 0, 0.25)',
        }}
      >
        {children}
      </Box>
    </Box>,
    document.body
  )
}

interface CenteredModalProps {
  open: boolean
  children: React.ReactNode
}
